import { CommonModule } from '@angular/common';
import { Component, OnChanges, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { StepperModule } from 'primeng/stepper'
import { CONSTANTS } from '../../../core/constants';
import { CommonService } from '../../../core/common.service';
import { filter, Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'app-tutor-onboarding',
  standalone: true,
  imports: [CommonModule,RouterModule,StepperModule],
  templateUrl: './tutor-onboarding.component.html',
  styleUrl: './tutor-onboarding.component.scss'
})
export class TutorOnboardingComponent implements OnInit,OnChanges,OnDestroy{
  tutorOnboardingRouteURL:string = '/tutor-signup/'
  active: number | undefined = 1;
  constants:any = CONSTANTS;
  profileStatus: any[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private _activatedRoute:ActivatedRoute,
    private _router:Router,
    private _commonService: CommonService
  ){
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.getActiveRouteUrl();
      this._commonService.getProfileStatus().subscribe();
    });
  }

  ngOnInit(): void {
    this.getActiveRouteUrl();
    this.getProfileStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getActiveRouteUrl();
  }

  getActiveRouteUrl(){
    switch (this._router.url) {
      case (this.tutorOnboardingRouteURL + this.constants?.tutorAboutUrl):
        this.active = 1;
      break;
      case (this.tutorOnboardingRouteURL + this.constants?.tutorSubjectsUrl):
        this.active = 2;
      break;
      case (this.tutorOnboardingRouteURL + this.constants?.tutorLanguagesUrl):
        this.active = 3;
      break;
      case (this.tutorOnboardingRouteURL + this.constants?.tutorEducationUrl):
        this.active = 4;
      break;
      case (this.tutorOnboardingRouteURL + this.constants?.tutorExperienceUrl):
        this.active = 5;
      break;
      case (this.tutorOnboardingRouteURL + this.constants?.tutorAvailibilityUrl):
        this.active = 6;
      break;
      case (this.tutorOnboardingRouteURL + this.constants?.tutorRatPerHourUrl):
        this.active = 7;
      break;
      case (this.tutorOnboardingRouteURL + this.constants?.tutorSubmitUrl):
        this.active = 8;
        break;
      default:
        this.active = 1;
      break;
    }
  }

  getProfileStatus() {
    this._commonService.getProfileStatus().subscribe();
    this._commonService.profileStatus$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(status => {
      if (status) {
        this.profileStatus = status;
      }
    });
  }

  isStepFinished(stepKey: string, stepIndex: number): boolean {
    const step = this.profileStatus.find(s => s.step_key === stepKey);
    return step ? (
      step.status === 'completed' || 
      step.status === 'skipped' || 
      step.status === 'submitted' || 
      step.status === 'approved'
    ) : false;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}